import { AgGridReact } from 'ag-grid-react';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { ServerGridConfig } from '../../../../config/GridConfig';
import Message from '../../../../config/Message';
import { Button } from 'antd';
import { ModuleRegistry } from '@ag-grid-community/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { ServerSideRowModelModule } from 'ag-grid-enterprise';

const ListComponent = observer((props) => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	const { openEditModal, openDeleteModal } = props;
	const { ADMINSETTINGS } = useStore();

	const ActionRenderer = (props) => {
		return (
			<div className="action-column">
				<Button
					type="text"
					title={'Edit'}
					className="editIcon"
					onClick={() => {
						ADMINSETTINGS.ReadAdminSettings(props.data.id);
						openEditModal();
					}}
				>
					<FontAwesomeIcon icon={faPencil} />
				</Button>
				<Button
					type="text"
					title={'Delete'}
					className="deleteIcon"
					onClick={() => {
						openDeleteModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faTrashAlt} color={'red'} />
				</Button>
			</div>
		);
	};

	const colDefs = [
		// {
		// 	headerName: 'Sr. No',
		// 	valueGetter: 'node.rowIndex + 1',
		// 	minWidth: 80,
		// 	sortable: false,
		// },
		{
			headerName: 'Setting Name',
			field: 'settingName',
			sort: 'asc',
			minWidth: 140,
		},
		{
			headerName: 'Setting Key',
			field: 'settingKey',
			minWidth: 140,
		},
		{
			headerName: 'Setting Value',
			field: 'settingValue',
			minWidth: 140,
		},
		{
			headerName: 'Setting DBType',
			field: 'settingdbType',
			minWidth: 140,
			width: 140,
		},
		{
			headerName: 'Actions',
			field: 'actions',
			cellRenderer: 'ActionRenderer',
			pinned: 'right',
			sortable: false,
			filter: false,
			minWidth: 120,
			width: 120,
		},
	];

	return (
		<div
			className="ag-theme-quartz" // applying the grid theme
			style={{ height: 'calc(100vh - 140px)' }} // the grid will fill the size of the parent container>
		>
			<AgGridReact
				onGridReady={ADMINSETTINGS.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
				components={{
					ActionRenderer,
				}}
			/>
		</div>
	);
});

export default ListComponent;
